import React from 'react';
import { cx } from '../../utils/cx.js';

const TONES = {
  brand: { soft: 'bg-brand-50 text-brand-600 dark:bg-brand-900 dark:text-brand-400', solid: 'bg-brand-600 text-white' },
  blue: { soft: 'bg-[#e6f0ff] text-[#2f6df0] dark:bg-blue-900/30 dark:text-blue-300', solid: 'bg-[#2f6df0] text-white' },
  green: { soft: 'bg-[#e2f5ea] text-[#16a866] dark:bg-green-900/30 dark:text-green-300', solid: 'bg-[#16a866] text-white' },
  amber: { soft: 'bg-[#fdf0d8] text-[#d9870f] dark:bg-amber-900/30 dark:text-amber-300', solid: 'bg-[#f5a623] text-white' },
  slate: { soft: 'bg-[#e8edf4] text-[#3a4a63] dark:bg-slate-700/50 dark:text-slate-200', solid: 'bg-[#3a4a63] text-white' },
  red: { soft: 'bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-300', solid: 'bg-red-600 text-white' },
  gray: { soft: 'bg-gray-100 text-gray-600 dark:bg-white/5 dark:text-gray-300', solid: 'bg-gray-700 text-white' },
};

const SIZES = {
  sm: { box: 'h-6 w-6 rounded-md', icon: 'h-3.5 w-3.5' },
  md: { box: 'h-9 w-9 rounded-lg', icon: 'h-[18px] w-[18px]' },
  lg: { box: 'h-12 w-12 rounded-xl', icon: 'h-6 w-6' },
};

/** Tinted square holding an icon — the header marker of every Insights card. */
const IconChip = ({ icon: Icon, tone = 'brand', size = 'md', solid = false, className = '' }) => {
  const t = TONES[tone] || TONES.brand;
  const sz = SIZES[size] || SIZES.md;
  return (
    <span className={cx('inline-flex flex-shrink-0 items-center justify-center', sz.box, solid ? t.solid : t.soft, className)} aria-hidden>
      <Icon className={sz.icon} />
    </span>
  );
};

export default IconChip;
